import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
  html {
    box-sizing: border-box;
  }
  
  *, *::after, *::before {
    box-sizing: inherit;
  }
  
  body {
    margin: 0;
    padding: 0;
  }
  h1{
    font-family: JetBrains Mono;
  }
  h2,h3,h4,h5,h6, p,input,label{
    font-family: "Inter", sans-serif;
  }

  a, button {
    font-family: JetBrains Mono;
  }
  .App{
    padding: 20px;
    min-height: 712px;
  }
`;
